// ABOUTME: Configuration for the return reasons settings page.
// ABOUTME: Defines tab structure and icons for the ReturnReasons TabView3.

import { WarehouseOutlined } from '@mui/icons-material';

export const returnReasonsConfig = {
    all: {
        title: 'return_reasons',
        icon: <WarehouseOutlined />,
        isSingleDataGrid: true,
    },
};
